import $ from 'jquery';
import PubSub from '../../../src/js/utils/pub-sub';
import {toggleAttribute} from '../../../src/js/utils/helpers';
import smoothScroll from '../../../src/js/utils/smoothScroll';

// mock ajax call getting json list
var searchList ;

const KEY = {
  UP: 38,
  DOWN: 40,
  ESC: 27,
  ENTER: 13,
  SPACE: 27
};

const MIN_SEARCH_CHARS = 3;

export class SearchBox {

  constructor({$el, itemIdPrefix}) {
    this.root = $el instanceof $ ? $el : $($el);
    this.itemIdPrefix = itemIdPrefix;
    this.searchField = this.root.find('.js-main-search_field');
    this.searchLabel = this.root.find('.js-main-search_label');
    this.searchEraseBtn = this.root.find('.js-main-search_erase');
    this.searchResultList = this.root.find('.js-main-search_list');
    this.goResultsBtn = $('.JS--resultbutton');
    this.isAlwaysOpen = this.root.hasClass('is-open');
    this.isResultListOpen = false;
    this.currentItemFocus = null;
    this.resultListLen = 0;
    this.focusIndex = -1;

    this.loadList();
    this.handleEvents();

  }

  _destroy() {
    console.log('destroy in SearchBox');
    this.root.off();
  }

  loadList() {
      var url = $("#hidden-autocompletion-file").html();
      if (url) {
          $.ajax({
              url: url.trim(),
              method: "GET",
              dataType: "json",
              success: function (response) {
                  searchList = response.filterList;
              },
              error: function () {
                  console.log('Erreur du chargement de la liste');
              }
          });
      }
  };

  handleEvents() {
    this.root.submit(e => {
      if (this.isEmpty(this.searchField.val()) || this.focusIndex !== -1) {
        e.preventDefault();
      }
    });

    this.searchEraseBtn.mousedown(e => {
      e.preventDefault();
      this.hideEraseBtn();
      this.searchField.val('');
      this.searchResultList.html('');
      this.searchField.focus();
    });

    this.searchField.focus( e => { 
     this.root.addClass('is-active');
    });

    this.searchField.click( e => {
      e.stopPropagation();
    });

      // bind on click JS--resultbutton
      this.goResultsBtn.click( e => {
          e.preventDefault();
          e.stopPropagation();
          if (this.searchField.val() !== "" && this.searchField.val() !== null) {
              this.submitMainSearchField(this.searchField);
          }
      });

    // Bind on key down and perform search with "enter"
    this.searchField.keydown(e => {
      e.stopPropagation();
      this.handleKeyDown(e);
    });

    // bind on click on autocomplete element
    this.searchResultList.mousedown(e => {
      if (e.target.tagName === 'LI') {
        this.searchField.val(this.trimSpaces(e.target.textContent));

        // Perform the search
        this.submitMainSearchField(this.searchField);
      }
    });

    // Css animation of text research when user leave search box
    this.searchField.blur(e => {
      if (this.isEmpty(e.target.value)) {
        this.root.removeClass('is-active');
      }

      this.emptyList();
    }); 

    this.searchField.keyup(e => {
      switch (this.shouldStartAutoCompletion()) {
        case true:
          if (this.shouldStartAutoCompletion()) {
            this.focusIndex = -1;
            this.emptyList();
          };
        break;
        case false:
          if (e.keyCode === KEY.DOWN ||
              e.keyCode === KEY.UP ||
              e.keyCode === KEY.ENTER ||
              e.keyCode === KEY.SPACE) return;

          this.focusIndex = -1;
          this.openList();
          this.buildResultList(e);
        break;
      }

      if (this.searchField.val() !== "") {
        this.showEraseBtn();
      } else {
        this.hideEraseBtn();
      }
    });
  }

  handleKeyDown(e) {
    e.stopPropagation();
    let index;

    switch (e.keyCode) {
      case KEY.ENTER:
        e.preventDefault();
        if (this.focusIndex > -1) {
          this.searchField.val(
            this.getItemValueByIndex(this.focusIndex)
          );
          this.focusIndex = -1;
          this.emptyList();
          this.updateActiveDescendantByIndex(this.focusIndex);
        }
        if (this.searchField.val() !== "" && this.searchField.val() !== null) {
          this.submitMainSearchField(this.searchField);
      }
      break;
      case KEY.ESC:
        this.searchField.val('');
        this.focusIndex = -1;
        this.emptyList();
        this.hideEraseBtn();
      break;
      case KEY.DOWN:
        e.preventDefault();
        index = this.getNextIndex(this.focusIndex);

        if (index === this.focusIndex) {
          return;
        }

        this.removePseudoFocus(this.focusIndex);
        this.addPseudoFocus(index);
        this.updateActiveDescendantByIndex(index);
        this.focusIndex = index;
      break;
      case KEY.UP:
        e.preventDefault();
        index = this.getPrevIndex(this.focusIndex);

        if (index === this.focusIndex) {
          return;
        }

        this.removePseudoFocus(this.focusIndex);
        this.addPseudoFocus(index);
        this.focusIndex = index;
      break;
    }
  }

  addPseudoFocus(index) {
    this.searchResultList.find('li').eq(index).addClass('is-focus');
	this.searchResultList.find('li').eq(index).attr("aria-selected","true");
  }

  removePseudoFocus(index) {
    this.searchResultList.find('li').eq(index).removeClass('is-focus');
	this.searchResultList.find('li').eq(index).attr("aria-selected","false");
  }

  updateActiveDescendantByIndex(index) {
    this.searchField.attr(
      'aria-activedescendant',
      this.getItemIdByIndex(index)
    );
  }

  submitMainSearchField(element) { // element = searchfield
      //element.prop('disabled', true); 
	  var actualpage = window.location.href;	
	  var action = element.closest('form').attr('action');
	  // 2788 + 2741
      var keywordValue = btoa(element.val()+"p").replace(/=/g, '');      
      window.location.href = action+"#keyword=" + keywordValue;
	  // If previous page was already searchpage: force reload
	  if (actualpage.indexOf("resultats-recherche")>=0) 
		window.location.reload(true);
	  //window.location.assign(action+"#keyword=" + keywordValue);
  }

  getItemIdByIndex(index) {
    if (index === -1) return null;
    return this.itemIdPrefix + '-' + index;
  }

  trimSpaces(str) {
    return str.replace(/^\s+|\s+$/g, "");
  }

  getItemValueByIndex(index) {
    return this.trimSpaces(
        this.searchResultList
          .find('li')
          .eq(index)
          .text()
        );
  }

  getNextIndex(index) {
    return Math.min(index + 1, this.resultListLen - 1);
  }

  getPrevIndex(index) {
    return Math.max(index - 1, 0);
  }

  showEraseBtn() {
    this.searchEraseBtn.addClass('is-active');
  }

  hideEraseBtn() {
   this.searchEraseBtn.removeClass('is-active');
  }

  emptyList() {
    this.searchResultList.html('');
	this.searchField.attr("aria-expanded","false");
  }

  buildResultList(e) {
    let searchEntry = this.escapeRegexpChars(this.searchField.val());
    var resultList = "";
    
    this.resultListLen = 0;
    this.searchField.html('');

      if (this.isSearchListDefined()) {
              searchList
                  .filter( (listEntry) => this.hasItem(listEntry, searchEntry)
          )
          .forEach( (item, index) => {
            let itemWithHighlight = this.highlight(item, searchEntry);

            resultList += `<li
                            id='${this.itemIdPrefix}-${index}'
                            class='dcw_main-search_item' role='option' aria-selected='false'>
                            ${itemWithHighlight}
                           </li>`;

            this.resultListLen++;
        });
    }

    this.searchResultList.html(resultList);
  }

  escapeRegexpChars(chars) {
    return chars.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  }

  highlight(listEntry, searchEntry) {
    return listEntry.replace(
      searchEntry, 
      `<span>${searchEntry}</span>`
    );
  }

  shouldStartAutoCompletion() {
    return this.searchField.val().length < MIN_SEARCH_CHARS && this.isSearchListDefined();
  }

  isSearchListDefined() {
    return  searchList !== undefined && searchList !== null;
    }

  hasItem(listEntry, searchEntry) {
    if (searchEntry === '') return;

    let regexp = new RegExp(searchEntry);

    return regexp.test(listEntry);
  }

  openList() {
    if (!this.isResultListOpen) {
      this.isResultListOpen = true;
      this.searchResultList.css('display', 'block');
    }
	this.searchField.attr("aria-expanded","true");
  }

  resetSearch() {
    this.searchField.val('');
    this.searchResultList.html('');
    this.root.removeClass('is-active');
    this.hideEraseBtn();
    this.currentItemFocus = null;
  }

  isEmpty(value) {
    return value === "";
  }
}

class MainSearch extends SearchBox {

  constructor(opts) {
    super(opts);

    this.searchWrapper = $('.js-main-search_wrapper');
    this.searchContainer = $('.js-main-search_container');
    this.searchToggle = $('.js-main-search_toggle');
    this.searchCloseBtn = $('.js-main-search_close');

    this.handleSpecificEvents();
  }

  _destroy() {
    SearchBox.prototype._destroy.call(this);
    this.searchCloseBtn.off('click', this._onCloseBtnClick);
    this.searchToggle.off('click', this._onSearchToggleClick);
  }

  handleSpecificEvents() {
    this._onSearchToggleClick = e => {
      this.resetSearch();
      this.handleClick(e);
      setTimeout(() => this.searchField.focus());
    };

    this._onCloseBtnClick = e => {
      this.handleClick(e);
    };

    this.searchToggle.click(this._onSearchToggleClick);
    this.searchCloseBtn.click(this._onCloseBtnClick);
  }
}

export class MainSearchAuth extends MainSearch {

  constructor(opts) {
    super(opts);

    this.activeItem = $('.js-menu_item.is-active');
    this.navContainer = this.activeItem.find('.dcw_submenu-auth');
    this.activeNav = null;
    this.isOpen = false;
    this.searchWrapper.removeClass('dcw_submenu-auth_search-wrapper--fill');

    if (this.activeItem.length) {
      this.activeNav = this.navContainer;

      if (this.activeNav.length == 0) {
          this.activeNav = $('.dcw_submenu-auth--persistent');
      }
    } else {
        this.activeNav = $('.dcw_submenu-auth--persistent');
    }


    this._stopSearchPropagation = e => e.stopPropagation;
    this.searchWrapper.click(this._stopSearchPropagation);
  }

  destroy() {
    this._destroy();
    this.unbindOutEvents();
    this.searchWrapper.off('click', this._stopSearchPropagation);
  }

  handleClick(e) {
    e.preventDefault();
    this.toggleSearchPane();
  }


  toggleNavigations() {
    this.activeNav.toggleClass('is-search-open');
  }

  toggleSearchPane() {
    let isSticky = $('.dcw_header').hasClass('is-sticky');
    this.handleExtEvents();
    this.toggleNavigations();
    toggleAttribute(this.searchToggle, 'aria-expanded');

    if (isSticky && !this.isOpen) {
      this.expandNavContainer();
    }
    else if (isSticky && this.isOpen) {
      this.navContainer.css('height', '');
    }

    this.searchWrapper.toggleClass('is-open-add');

    setTimeout(() => {
      this.searchWrapper.toggleClass('is-open');
      this.isOpen = !this.isOpen;
    }, 30);
    
    this.searchCloseBtn.css('display', 'block');

  }

  expandNavContainer() {
    this.navContainer.css('height', '160px');
  }

  handleExtEvents() {
    if (!this.isOpen) {
      setTimeout(() => {
        this.bindOutsideClick();
        this.bindOutsideScroll();
      });
    } else {
      this.unbindOutEvents();
    }
  }

  onOutsideClickCallback(self) {
    return function (e) {
      self.toggleSearchPane();
      self.unbindOutEvents();
    }
  }

  onOutsideScrollCallback(self) {
    return function () {
      self.toggleSearchPane();
      self.unbindOutEvents();
    }    
  }

  bindOutsideScroll() {
    this.onOutsideScroll = this.onOutsideScrollCallback(this);
    $(window).scroll(this.onOutsideScroll);
  }

  bindOutsideClick() {
    this.onOutsideClick = this.onOutsideClickCallback(this);
    $(window).click(this.onOutsideClick);
  }

  unbindOutEvents() {
    $(window).off('click', this.onOutsideClick);
    $(window).off('scroll', this.onOutsideScroll);
  }
}

export class MainSearchUnAuth extends MainSearch {

  constructor($el) {
    super($el);
    this.isOpen = false;
    this.isCalled = false;
    this.main = $('.dcw_main');
    this.searchWrapper = $('.dcw_main-nav_search').find('.js-mega-menu');

    this._onSearchClose = () => this.closeSearch();
    PubSub.subscribe('search:close', this._onSearchClose);
  }

  destroy() {
    this._destroy();
    this.unbindOutEvents();
    PubSub.unsubscribe('search:close', this._onSearchClose);
  }

  handleClick(e) {
    e.stopPropagation();
    e.preventDefault();

    let scrollPos = $(window).scrollTop();

    if (!this.isOpen && scrollPos > 272) {
      this.isCalled = false;
      smoothScroll.scrollTo(0, () => {
        if (this.isCalled) return;
        this.isCalled = true;
        this.toggleSearchPane(e);
      });
    } else {
      this.toggleSearchPane(e);      
    }
  }

  closeSearch() {
    this.unbindOutEvents();
    this.closeSearchPane();
  }

  toggleSearchPane(e) {
    let self = this;

    this.isAnimating = true;

    if (!this.isOpen) {

      $('.js-menu_item.is-active')
          .find('.is-open.is-open-add .js-mega-menu_btn-close')
          .click();

      this.openSearchPane(e);

    } else {
      this.unbindOutEvents();

      this.closeSearchPane();
    }

    toggleAttribute(this.searchToggle, 'aria-expanded');
  }

  toggleLastMenuOpen() {
    this.lastActiveMenu.toggleClass('is-open');
    this.lastActiveMenu.toggleClass('is-open-add');
  }

  openSearchPane(e) {
    this.searchWrapper.addClass('is-open-add');
    setTimeout(() => {
        this.searchWrapper.addClass('is-open');
    }, 30);
    setTimeout(() => {
      this.searchCloseBtn.css('display', 'block');
      this.isOpen = true;

      setTimeout(() => {
        this.bindOutsideClick();
        this.bindOutsideScroll();
      });
    }, 300);
  }

  closeSearchPane() {
    this.searchWrapper.removeClass('is-open');
    this.searchCloseBtn.css('display', '');
    setTimeout(() => {
        this.searchWrapper.removeClass('is-open-add');
        this.isOpen = false;
    }, 300);
  }

  getLastActiveMenu() {
    let lastActiveItem = $('.js-menu_item.is-active');
    let lastActiveMenu;

    if (lastActiveItem.length) {
      lastActiveMenu = lastActiveItem.find('.is-open.is-open-add');
    }

    return lastActiveMenu.length &&
      lastActiveMenu || 
      null
  }

  onOutsideClickCallback(self) {
    return function () {
      self.toggleSearchPane();
      self.unbindOutEvents();
    }
  }

  onOutsideScrollCallback(self) {
    return function () {
      let windowWidth = window.innerWidth;
      if (windowWidth < 768 || windowWidth > 1024) {
        self.toggleSearchPane();
        self.unbindOutEvents();
      }
    }    
  }

  bindOutsideScroll() {
    this.onOutsideScroll = this.onOutsideScrollCallback(this);
    $(window).scroll(this.onOutsideScroll);
  }

  bindOutsideClick() {
    this.onOutsideClick = this.onOutsideClickCallback(this);
    $(window).click(this.onOutsideClick);
  }

  unbindOutEvents() {
    $(window).off('click', this.onOutsideClick);
    $(window).off('scroll', this.onOutsideScroll);
  }
}


// WEBPACK FOOTER //
// ./src/components/search-field/mainSearch.js